// app/frontend/script/components/toggle-module.js
export default function initToggles(root = document) {
  const triggers = root.querySelectorAll("[data-toggle-trigger]");

  triggers.forEach((trigger) => {
    // Prevent double-binding (Turbo visits / renders)
    if (trigger.dataset.toggleInitialized === "1") return;
    trigger.dataset.toggleInitialized = "1";

    trigger.addEventListener("click", (e) => {
      // If your trigger can be inside links, this is safer than tagName === "A"
      const link = e.target.closest("a");
      if (link && link === trigger) return;

      const container =
        trigger.closest("[data-toggle-container]") || document.body;

      const key = trigger.dataset.toggleTrigger;
      const target = key
        ? container.querySelector(`[data-toggle-content="${CSS.escape(key)}"]`)
        : trigger.nextElementSibling;

      if (!target) {
        // Don't throw, just log and bail
        console.warn("[toggle-module] No target found for trigger:", trigger);
        return;
      }

      const exclusive = trigger.dataset.toggleExclusive === "true";
      const isOpening = !trigger.classList.contains("is-open");

      if (exclusive && isOpening) {
        closeAllInContainer(container, trigger);
      }

      if (isOpening) {
        open(trigger, target);
      } else {
        close(trigger, target);
            }
          });
  });
}

function closeAllInContainer(container, exceptTrigger = null) {
  container.querySelectorAll("[data-toggle-trigger].is-open").forEach((t) => {
    if (exceptTrigger && t === exceptTrigger) return;

    t.classList.remove("is-open");
    rotateIcon(t, false);

    const key = t.dataset.toggleTrigger;
    const target = key
      ? container.querySelector(`[data-toggle-content="${CSS.escape(key)}"]`)
      : t.nextElementSibling;

    if (target) collapseElement(target);
          });
        }

function open(trigger, target) {
        trigger.classList.add("is-open");
  rotateIcon(trigger, true);

  expandElement(target);
        }

function close(trigger, target) {
        trigger.classList.remove("is-open");
  rotateIcon(trigger, false);

  collapseElement(target);
        }

function rotateIcon(trigger, open) {
  const icon = trigger.querySelector("svg");
  if (!icon) return;

  icon.style.transform = open ? "rotate(90deg)" : "rotate(0deg)";
  icon.classList.toggle("text-gray-600", open);
        }

/**
 * Expand to scrollHeight (+ vertical padding), then set maxHeight to "none"
 * so content can grow (e.g. responsive reflow) without breaking.
 */
function expandElement(el) {
  // Ensure it's measurable
  el.style.overflow = "hidden";

  // If you want padding on open, define it in CSS for the content element.
  // We'll read it here so no magic numbers are needed.
  const styles = window.getComputedStyle(el);
  const padTop = parseFloat(styles.paddingTop) || 0;
  const padBottom = parseFloat(styles.paddingBottom) || 0;

  // Start from collapsed state (important if it's newly inserted by Turbo)
  el.style.maxHeight = "0px";

  // Force a reflow so the browser registers maxHeight=0 before expanding
  // eslint-disable-next-line no-unused-expressions
  el.offsetHeight;

  const fullHeight = el.scrollHeight + padTop + padBottom;
  el.style.maxHeight = `${fullHeight}px`;

  // After the transition ends, allow it to grow naturally
  const onEnd = (evt) => {
    if (evt.propertyName !== "max-height") return;
    el.style.maxHeight = "none";
    el.removeEventListener("transitionend", onEnd);
  };
  el.addEventListener("transitionend", onEnd);
      }

function collapseElement(el) {
  el.style.overflow = "hidden";

  // If it was "none", set to current pixel height first so we can animate down to 0
  if (el.style.maxHeight === "none" || !el.style.maxHeight) {
    el.style.maxHeight = `${el.scrollHeight}px`;
    // force reflow
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;
}

  el.style.maxHeight = "0px";
}